import { useState } from "react";
import { Printer, Download, Loader2 } from "lucide-react";
import { downloadBrochurePdf } from "./pdf";
import { WHATSAPP_URL } from "./data";

const WhatsAppIcon = ({ size = 14 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M19.11 17.21c-.27-.14-1.62-.8-1.87-.89-.25-.09-.43-.14-.62.14-.18.27-.71.89-.87 1.08-.16.18-.32.2-.59.07-.27-.14-1.16-.43-2.21-1.36-.82-.73-1.37-1.63-1.53-1.9-.16-.27-.02-.42.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.62-1.49-.85-2.04-.22-.54-.45-.46-.62-.47l-.53-.01c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.28 0 1.34.98 2.64 1.12 2.82.14.18 1.94 2.97 4.71 4.16.66.28 1.17.46 1.57.59.66.21 1.26.18 1.73.11.53-.08 1.62-.66 1.85-1.3.23-.64.23-1.19.16-1.3-.07-.12-.25-.18-.52-.32zM16.02 5C9.93 5 5 9.93 5 16.02c0 1.95.51 3.86 1.48 5.54L5 27l5.59-1.46c1.62.88 3.45 1.34 5.43 1.34h.01C22.12 26.88 27 21.95 27 15.86 27 9.77 22.11 5 16.02 5z"/>
  </svg>
);

export default function Toolbar({ onPrint }) {
  const [generating, setGenerating] = useState(false);
  const [progress, setProgress] = useState({ done: 0, total: 0 });

  const handleDownload = async () => {
    if (generating) return;
    setGenerating(true);
    try {
      await downloadBrochurePdf({
        onProgress: (done, total) => setProgress({ done, total }),
      });
    } catch (e) {
      console.error("PDF generation failed", e);
      alert("Sorry, the PDF could not be generated. Try the Print button instead.");
    } finally {
      setGenerating(false);
      setProgress({ done: 0, total: 0 });
    }
  };

  const label = generating
    ? progress.total
      ? `Generating ${progress.done}/${progress.total}`
      : "Preparing…"
    : "Download PDF";

  return (
    <div className="toolbar no-print">
      <div className="toolbar-brand">
        <div className="toolbar-mark" />
        <span>INPACE POWER · BROCHURE</span>
      </div>
      <div className="toolbar-actions">
        <a
          data-testid="whatsapp-btn"
          className="btn btn-whatsapp"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <WhatsAppIcon size={14} />
          <span style={{ marginLeft: 8 }}>WhatsApp</span>
        </a>
        <button data-testid="print-brochure-btn" className="btn" onClick={onPrint} disabled={generating}>
          <Printer size={13} style={{ display: "inline", marginRight: 8, verticalAlign: "-2px" }} />
          Print
        </button>
        <button
          data-testid="download-pdf-btn"
          className="btn btn-primary"
          onClick={handleDownload}
          disabled={generating}
        >
          {generating ? (
            <Loader2 size={13} className="spin" style={{ display: "inline", marginRight: 8, verticalAlign: "-2px" }} />
          ) : (
            <Download size={13} style={{ display: "inline", marginRight: 8, verticalAlign: "-2px" }} />
          )}
          {label}
        </button>
      </div>
    </div>
  );
}
